import { z } from 'zod';

// What the identity-link round trip appends to whichever page started it.
export const securitySearchSchema = z.object({
  linked: z.enum(['google', 'facebook']).optional(),
  error: z.string().optional(),
});
